import { TimelineTheme } from '../../types';

const UNIDENTIFIED_CYCLE_HANDLE_COLOR = '#002185';

export const OUT_OF_RANGE_CYCLE_COLORS = {
	background: '#F8F8F8',
	selectedBackground: '#E6E6E6',
	border: '#E6E6E6',
	handles: '#BFBFBF'
};
const TIME_NEEDLE_COLOR = '#5474D1';

export const timelineTheme: TimelineTheme = {
	colors: {
		background: '#ffffff',
		ruler: '#505050',
		identifiedCycle: {
			background: 'rgba(251, 212, 185, 0.4)',
			border: '#F2751C',
			handles: '#F2751C',
			hoverBackground: 'rgba(251, 212, 185, 0.6)'
		},
		unidentifiedCycle: {
			background: 'rgba(84, 116, 209, 0.4)',
			handles: UNIDENTIFIED_CYCLE_HANDLE_COLOR,
			hoverBackground: 'rgba(84, 116, 209, 0.6)'
		},
		outOfRangeCycle: OUT_OF_RANGE_CYCLE_COLORS,
		error: 'rgba(255, 77, 79, 0.8)',
		timeNeedle: TIME_NEEDLE_COLOR
	},
	dimensions: {
		cycleBarHeight: 24,
		markerRadius: 4,
		markerWidth: 2,
		needleWidth: 2,
		triangleSize: 5,
		lineWidth: 1,
		borderWidth: 2,
		verticalOffset: 2
	}
};
